import { getTvObject, tv } from '@costar-ui/cosmos';

var innerRadioCircleTvObject = getTvObject({
  base: ['size-2.5', 'rounded-full', 'absolute', 'left-0', 'right-0', 'top-0', 'bottom-0', 'm-auto'],
  variants: {
    isSelected: {
      "true": 'bg-action-selected'
    }
  },
  compoundVariants: [{
    isSelected: true,
    isDisabled: true,
    className: 'bg-neutral-bold'
  }]
});
var innerRadioCircleStyles = tv(innerRadioCircleTvObject);

export { innerRadioCircleStyles, innerRadioCircleTvObject };
//# sourceMappingURL=inner-radio-circle.styles.esm.js.map
